var React = require('react');

function IconTick (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.icon-stroke {stroke-linejoin:round;}\n\t"),React.createElement("g",{"transform":"translate(-262.000000, -463.000000)","key":1},React.createElement("g",{"transform":"translate(262.000000, 463.000000)"},React.createElement("g",{"transform":"translate(40.000000, 0.000000)"},React.createElement("g",{"className":"icon-stroke","transform":"translate(8.000000, 8.000000)"},[React.createElement("path",{"d":"M112,56c0,30.9-25.1,56-56,56S0,86.9,0,56S25.1,0,56,0S112,25.1,112,56z","key":0}),React.createElement("polyline",{"points":"23,56.3 40,77.5 83.3,34.5","key":1})]))))]);
}

IconTick.defaultProps = {"version":"1.1","viewBox":"0 0 208 128","className":"icon-tick"};

module.exports = IconTick;

IconTick.default = IconTick;
